<script setup lang="ts">
import { T } from '@tolgee/vue'
import { computed } from 'vue'
import { useShop } from '@/composables/game/shop'
import { useMysteryBoxes } from '@/composables/game/mystery-boxes'
import { formatDuration } from '@/helpers/date'
import DefaultDiscountBadge from '@/components/periodic/default-discount/DefaultDiscountBadge.vue'
import IWDBadge from '@/components/periodic/IWD/IWDBadge.vue'
import DefaultBOGOBadge from '@/components/periodic/default-BOGO/DefaultBOGOBadge.vue'
import STPBadge from '@/components/periodic/STP/STPBadge.vue'
import DefaultBOGXBadge from '@/components/periodic/default-BOGX/DefaultBOGXBadge.vue'

const { canHaveSale } = useMysteryBoxes()
const { countdownForSaleEnds, isSale, isDefaultDiscount, isDefaultBOGO, isIWD, isSTP, isDefaultBOGX } = useShop()

const hasSale = computed(() => canHaveSale.value && isSale.value)

</script>

<template>
  <div class="relative h-[52px] w-[48px] translate-y-1">
    <div class="relative size-[48px] rounded-[15px] flex items-center justify-center bg-mystery-box-container">
      <div
        v-if="hasSale"
        class="absolute -left-2.5 -top-2.5 size-[38px] z-[3]"
      >
        <DefaultDiscountBadge
          v-if="isDefaultDiscount"
        />
        <DefaultBOGOBadge
          v-else-if="isDefaultBOGO"
        />
        <DefaultBOGXBadge
          v-else-if="isDefaultBOGX"
        />
        <IWDBadge v-else-if="isIWD" />
        <STPBadge v-else-if="isSTP" />
      </div>
      <div
        class="flex items-center justify-center h-full w-full overflow-hidden rounded-[15px] border-2 border-white/30 relative"
      >
        <img
          class="h-full w-auto object-cover z-[1] shadow-mystery-box"
          src="@/assets/images/gifs/mystery-box.gif"
        >
        <img
          class="absolute h-[34px] w-auto object-cover z-[2] shadow-question-mark"
          src="@/assets/images/question-mark2.png"
        >
      </div>

      <div class="absolute left-1/2 -translate-x-1/2 h-[18px] px-1.5 top-[38px] rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-dark-top-most-layer z-[4] whitespace-nowrap">
        <span
          v-if="hasSale"
          :class="countdownForSaleEnds < (3600 * 12) && 'text-red-accent'"
        >
          {{ formatDuration(countdownForSaleEnds, undefined, countdownForSaleEnds > (3600 * 72)) }}
        </span>
        <span v-else>
          <T
            key-name="tap.mystery_box"
            default-value="Mystery Box"
          />
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.shadow-mystery-box {
	filter: drop-shadow(0px 0px 12px #F88E15);
}

.bg-mystery-box-container {
	background: linear-gradient(170deg, #F88F15 7.58%, #BC4DA7 32.36%, #7B7BFF 69.55%);
}

.shadow-question-mark {
	filter: drop-shadow(0px 0px 16px #FFF);
}
</style>
